import { Pipe, PipeTransform, inject } from '@angular/core';

import { ResourcesService } from '@mitsubishi/core';
import { PerformanceValue } from '@mitsubishi/shared/data-access';

import { isNil } from '@angular-ru/cdk/utils';

@Pipe({
  name: 'apmPerformanceDescription',
  standalone: true,
})
export class PerformanceDescriptionPipe implements PipeTransform {
  #resourcesService = inject(ResourcesService);

  transform(value: Partial<PerformanceValue> | undefined | null): string {
    if (isNil(value)) {
      return '-';
    }

    return this.#resourcesService.getTextResourceWithPrefixSuffix({
      resourceId: value.resourceId,
      suffixResourceId: value.suffixResourceId,
      prefixResourceId: value.prefixResourceId,
    });
  }
}
